// extracted by mini-css-extract-plugin
export default {"sendGift":"vysicI9LrUzEcdYmNkIX","report":"AWsOj561RYNazfuw7PXB"};